
export const viewerJsOption = {
    toolbar: {
        zoomIn: {
          size: "large"
        },
        zoomOut: {
          size: "large"
        },
        oneToOne: {
          size: "large"
        },
        reset: {
          size: "large"
        },
        prev: {
          size: "large"
        },
        next: {
          size: "large"
        },
        rotateLeft: {
          size: "large"
        },
        rotateRight: {
          size: "large"
        },
        flipHorizontal: {
          size: "large"
        },
        flipVertical: {
          size: "large"
        }
      },
      inline: false,
      navbar: false,
}